/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [comment-navigation.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 17.02.20, 16:42
 */

import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {EmojiButton, HtmlTooltipLink} from "../navigation/buttons/nav-buttons";
import {getUserAvatar} from "../../actions/environment";
import {allowLikes as getAllowLikes, useAuthorization} from "../../selectors";

import {asyncCreateCommentLike, asyncRemoveCommentLike} from "../../actions/index";
import LikeNavigationTooltip from "../like/like-navigation-tooltip";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import {ThumbUpIcon} from "../navigation/icons/nav-icons";

const CommentNavigation = ({comment, postId, html}) => {
    const [ownLike, setOwnLike] = useState(null);
    const {principalUsername} = useAuthorization();
    const allowLikes = useSelector(state => getAllowLikes(state));
    const commentLikes = useSelector(state => state.commentLikes ? state.commentLikes[comment.id] : [])
    const dispatch = useDispatch();

    useEffect(() => {
        commentLikes && commentLikes.map(like => {
            if (principalUsername === like.user.username) {
                setOwnLike(like);
            }
        })
    }, [commentLikes])

    const handleLike = (event) => {
        event.preventDefault();
        if (ownLike) {
            dispatch(asyncRemoveCommentLike(principalUsername, postId,
                comment.id, ownLike.id, () => {
                setOwnLike(null);
            }));
        } else {
            dispatch(asyncCreateCommentLike(principalUsername, postId,
                comment.id, {username: principalUsername, reaction: 'LIKE'},
                like => setOwnLike(like)));
        }
    };

    return <NavigationRow className='comment-navigation'>
        <NavigationGroup>
            <HtmlTooltipLink to={`/${comment.user.username}/home`}
                             html={html}
                             htmlParams={{theme: 'avatar'}}>
                <img className='comment-item-avatar' src={getUserAvatar(comment.user)}/>
                {comment.user.fullname}
            </HtmlTooltipLink>
            <span className='when'>{comment.when}</span>
        </NavigationGroup>

        {allowLikes && <NavigationGroup>
            <LikeNavigationTooltip reaction={'LIKE'} likes={commentLikes}/>
            <EmojiButton selected={ownLike} onClick={handleLike}>
                <ThumbUpIcon big/>
            </EmojiButton>

        </NavigationGroup>}
    </NavigationRow>
};

export default CommentNavigation;